import React from 'react';
import PageBanner from '../components/PageBanner';
import BookingForm from '../components/BookingForm';
import { Check } from 'lucide-react';

const RequestQuotePage = () => {
  return (
    <>
      <PageBanner
        title="Request Your Free Egypt Quote"
        subtitle="Tell us about your dream Egypt journey. Our specialists will design a personalized itinerary within 24 hours — completely free."
        image="https://images.unsplash.com/photo-1643806294235-3ee68b3bc9d2?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Request a Quote' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <div className="bg-[#f6f8fa] rounded-2xl p-8 border border-slate-100">
              <h2 className="font-serif text-[#304b71] text-2xl mb-2">Your dream Egypt journey starts here</h2>
              <p className="text-slate-600 text-sm mb-6">Share a few details and our Nile cruise experts will design your perfect itinerary.</p>
              <BookingForm defaultSubject="Custom Quote Request" />
            </div>
          </div>
          <aside className="lg:col-span-2">
            <h3 className="font-serif text-[#304b71] text-2xl mb-6">Why request a custom quote?</h3>
            <ul className="space-y-4">
              {[
                'Personalized itinerary designed around your travel dates and interests',
                'Compare 3–5 hand-picked cruise ships suited to your budget',
                'Complimentary cabin upgrades on availability',
                'Zero booking fees — the price you see is what you pay',
                'One dedicated Egypt specialist from planning to disembarkation',
                'Free date changes up to 30 days before departure',
              ].map((p) => (
                <li key={p} className="flex items-start gap-3 text-slate-700"><Check className="text-[#6a8aa4] flex-shrink-0 mt-1" size={18} /> {p}</li>
              ))}
            </ul>
            <div className="mt-10 p-6 bg-[#304b71] text-white rounded-2xl">
              <div className="font-serif text-xl mb-2">Response guarantee</div>
              <p className="text-white/80 text-sm">Every quote request is answered by a real Egypt specialist within 24 hours — usually much sooner.</p>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
};

export default RequestQuotePage;
